import { useSetAtom } from "jotai";
import { UseFormHandleSubmit } from "react-hook-form";
import { setModalCloseAtom } from "atoms/modalAtom/modalAtom";
import { useEmployeesState } from "atoms/employeesAtom";

import { Button, EButtonVariant } from "components/Button/Button";

import { useAddEmployeesGroup, useEditEmployeesGroup } from "./api";
import { FormEmployeesGroup } from "./EmployeesGroupModal";

type Props = {
  handleSubmit: UseFormHandleSubmit<FormEmployeesGroup>;
  isEdit?: boolean;
};

export function ModalFooter({ handleSubmit, isEdit }: Props) {
  const { employeesState } = useEmployeesState();
  const closeModal = useSetAtom(setModalCloseAtom);
  const { mutate: addEmployeesGroup } = useAddEmployeesGroup();
  const { mutate: editEmployeesGroup } = useEditEmployeesGroup();

  const handleSave = (data: FormEmployeesGroup) => {
    if (isEdit) {
      editEmployeesGroup({
        usersgroupid: employeesState.activeGroupItem?.item.usersgroupid || "",
        name: data.name,
        accessList: data.checkedAccess,
      });
    } else {
      addEmployeesGroup({
        name: data.name,
        accessList: data.checkedAccess,
      });
    }

    closeModal();
  };

  return (
    <Button
      variant={EButtonVariant.SECONDARY}
      icon="galochka"
      onClick={handleSubmit(handleSave)}
    >
      Сохранить
    </Button>
  );
}
